if (!window.cansweetCookiePreferencesBound) {
  window.cansweetCookiePreferencesBound = true;
  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-cansweet-cookie-preferences]') : null;
    if (!button) return;
    const error = button.parentElement.querySelector('[data-cansweet-cookie-error]');
    error.hidden = true;
    button.disabled = true;
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error();
      await window.privacyBanner.showPreferences();
      await new Promise(resolve => setTimeout(resolve, 500));
      const hasVisibleDialog = () => [...document.querySelectorAll('[role="dialog"], [aria-modal="true"]')]
        .some(dialog => dialog.getClientRects().length && dialog.textContent.trim() && getComputedStyle(dialog).visibility !== 'hidden');
      if (!hasVisibleDialog()) {
        await window.privacyBanner.showPreferences();
        await new Promise(resolve => setTimeout(resolve, 1000));
      }
      if (!hasVisibleDialog()) throw new Error();
    } catch {
      error.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
}
